import React from 'react'
import NewCommonServiceContent from '../../../common/NewCommonServices/NewCommonServiceContent'
import img from "../../../../assets/images/serviceImages/CloudDevopsWork.webp"


const CloudAndDevopsWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <img src={img } className='w-full rounded-[16px]' alt=''/>
        </div>
      </NewCommonServiceContent>
    </div>
  )
}

export default CloudAndDevopsWork